import React from 'react';
import SingleJobLeadsDetails from '../components/atoms/LeadsDetails/SingleJobLeadsDetails';

const SingleImportJob = () => {
  return <SingleJobLeadsDetails />;
};

export default SingleImportJob;
